import { connect } from 'react-redux'
import { IStoreState } from '../../types'
import { getServiceProgram } from '../../state/reducers/service-program/service-program'
import { updateServiceProgram } from '../../state/actions/service-program/service-program'
import { RouteComponentProps } from 'react-router'
import { IServiceProgramObject } from '../../types/service-program'
import ServiceProgramEditModal from '../../components/global-settings/ServiceProgramEditModal'

const mapStateToProps = (state: IStoreState, ownProps: RouteComponentProps<any>) => {
  return {
    serviceProgram: getServiceProgram(state, ownProps.match.params.id),
    routeProps: ownProps
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    onUpdate: (serviceProgram: IServiceProgramObject) => {
      return dispatch(updateServiceProgram(serviceProgram))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ServiceProgramEditModal)



// WEBPACK FOOTER //
// ./src/containers/service-program/ServiceProgramEditModal.ts